import EnvService from "../../../core/services/env";

/**
 * This interface houses all the available endpoints of this application specific for the 'biz-print' server.
 */
class ApiEndpoints {

    /**
     * The base url of the api endpoints of this application.
     * @private
     */
    public static baseUrl: string = EnvService.apiEndpointUrl + '/api';
    public static cmsBaseUrl: string = EnvService.CMSApiEndpointUrl + '/api';

    /**
     * The controllers of the api endpoints.
     * @private
     */
    public static controllers = {
        demoContact: this.baseUrl.concat("/demoContact"),
        blogs: this.cmsBaseUrl,
    }

    /**
     * The endpoints specific for the blogs controller.
     */
    public static blogs = {
        baseUrl: this.controllers.blogs,
        getCategoriesByType: (type: "Video" | "Blog") => this.controllers.blogs.concat(`/Category/GetAllByType/${encodeURIComponent(type)}`),
        searchPosts: this.controllers.blogs.concat(`/Post/Search`),
        getPostBySlug: (slug: string) => this.controllers.blogs.concat(`/Post/${encodeURIComponent(slug)}`),
    }

    /**
     * The endpoints specific for the auth controller of the server api.
     */
    public static demoContact = {
        baseUrl: this.controllers.demoContact,
        submitADemoRequest: this.controllers.demoContact,
    }
}

export default ApiEndpoints;
